import { gql } from '@cedarjs/web'

export const SUBMIT_REFERENCE_FEEDBACK = gql`
  mutation SubmitReferenceFeedback($input: SubmitReferenceFeedbackInput!) {
    submitReferenceFeedback(input: $input) {
      id
    }
  }
`
